import { Flex } from 'foundations-components/components/Flex';
import PropTypes from 'prop-types';
import { memo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const PrimaryMessageHeaderContent = ({
  children
}) => {
  return /*#__PURE__*/_jsx(Flex, {
    minInlineSize: "0",
    marginInlineEnd: "auto",
    inlineSize: "100%",
    alignItems: "center",
    "data-test-id": "primary-message-header-content",
    children: children
  });
};
PrimaryMessageHeaderContent.displayName = 'PrimaryMessageHeaderContent';
PrimaryMessageHeaderContent.propTypes = {
  children: PropTypes.node.isRequired
};
export default /*#__PURE__*/memo(PrimaryMessageHeaderContent);